import React from 'react';
import { Typography, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <Title level={2}>{t('privacyPolicy.title')}</Title>
      <Divider />
      <Paragraph>
        <strong>{t('privacyPolicy.lastUpdated')}</strong> April 3, 2025
      </Paragraph>
      <Paragraph>
        {t('privacyPolicy.intro')}
      </Paragraph>
      <Title level={3}>{t('privacyPolicy.section1.title')}</Title>
      <Paragraph>
        {t('privacyPolicy.section1.content')}
      </Paragraph>
      <Title level={3}>{t('privacyPolicy.section2.title')}</Title>
      <Paragraph>
        {t('privacyPolicy.section2.content')}
        <ul>
          <li>{t('privacyPolicy.section2.list.0')}</li>
          <li>{t('privacyPolicy.section2.list.1')}</li>
          <li>{t('privacyPolicy.section2.list.2')}</li>
        </ul>
      </Paragraph>
      <Title level={3}>{t('privacyPolicy.section3.title')}</Title>
      <Paragraph>
        {t('privacyPolicy.section3.content')}
      </Paragraph>
      <Title level={3}>{t('privacyPolicy.section4.title')}</Title>
      <Paragraph>
        {t('privacyPolicy.section4.content')}
      </Paragraph>
      <Title level={3}>{t('privacyPolicy.section5.title')}</Title>
      <Paragraph>
        {t('privacyPolicy.section5.content')}
      </Paragraph>
    </div>
  );
};

export default PrivacyPolicy;